<template>
  <div class="game_x">
    <h1>{{showGame.name}}</h1>
    <GameAboutPC :datas="showGame" :opts="''" @events="gameEvents" />
  </div>
</template>

<script>
// @ is an alias to /src
import GameAboutPC from '@/components/GameAboutPC.vue'
import tools from '@/tools/tools'

export default {
  name: 'HomePc',
  components: {
    GameAboutPC
  },
  data: () => {
    return {
      nowGame: {}
    }
  },
  mounted () {
    this.onToTop()
  },
  created () {
    console.log('独立游戏')
  },
  computed: {
    games () {
      return this.$store.state.configs.games
    },
    showGame () {
      let game = {
        name: '未找到游戏'
      }

      // 找到对应游戏
      for (let i = 0; i < this.games.length; i++) {
        const tgame = this.games[i]
        if (tgame.downKey === this.$route.params.id) {
          game = tgame
          break
        }
      }
      console.log(game)
      return game
    }
  },
  methods: {
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    gameEvents (vtype, vitem) {
      console.log(vtype, vitem)
      if (vtype === 'go_h5') {
        tools.openH5Url(vitem.h5Url)
      } else {
        tools.iosDoLocation(this.$store.getters.getDownNow(vitem.downKey))
      }
    }
  }
}
</script>

<style scoped>
.game_x {
  margin-top: 4rem;
  margin-bottom: 4rem;
}

</style>
